import * as React from 'react';
import type { SVGProps } from 'react';
const IconHamburgerMenu = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    data-xds="IconHamburgerMenu"
    role="presentation"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M21 7.75H3v-1.5h18zM21 12.75H3v-1.5h18zM21 17.75H3v-1.5h18z"
      clipRule="evenodd"
    />
  </svg>
);
export default IconHamburgerMenu;
